module.exports = __webpack_public_path__ + "resources/img/img_tibero_m.c4f952da1c3a3d83257af1b00cc217df.png";